// Controller Functions for METRC Preference Settings
// This file contains all of the business logic for dealing with METRC preferences
import axiosInstances from '@/../../coreui/server/axiosInstances'
import phraseProc from '@/../../library/helper/phrase.js'

export default {
    methods: {
        async getExisting(id) {
            if(id === undefined) return null
            console.log('Get Existing ID = ', id)
            let prefRecord = await axiosInstances.loginServer.get(`/dt/v1/auth_metrc_default/${id}`)
            let prefRecordData = prefRecord.data
            console.log(`Pref Data = `, prefRecordData)
            let nameKey = prefRecordData.namekey
            let descKey = prefRecordData.desckey

            let namePhrase = await phraseProc.getPhrase(nameKey)
            let descPhrase = await phraseProc.getPhrase(descKey)

            prefRecordData["namePhrase"] = namePhrase
            prefRecordData["descPhrase"] = descPhrase
            return prefRecordData
        },
        async createRecord(payload) {
            console.log(`Sending the record data for further processing`, payload)
            payload["action"] = "metrc_global_pref_create"
            payload["prefix"] = "metrc"
            await axiosInstances.loginServer.post("/dt/v1/temp_manage_intake", payload);
        },
        async updateRecord(payload){
            console.log(`Sending the record data for further processeing`, payload)
            payload["action"] = "metrc_global_pref_update"
            payload["prefix"] = "metrc"
            await axiosInstances.loginServer.post("/dt/v1/temp_manage_intake", payload)
        },
        async getGlobalPrefList() {
            console.log(`Getting the global preference list`)
            let listRecord = await axiosInstances.loginServer.get(`/dt/v1/auth_metrc_default`)
            let listData = listRecord.data
            return listData
        }

    }
}

